export const UPDATE_STATUS_FILTER = 'coupons/UPDATE_STATUS_FILTER'
export const UPDATE_SEARCH_TEXT = 'coupons/UPDATE_SEARCH_TEXT'
export const UPDATE_COUPONS = 'coupons/UPDATE_COUPONS'
export const UPDATE_COUPON_ID_LIST = 'coupons/UPDATE_COUPON_ID_LIST'


